"use client";

import LABELS from "@/components/global-constant/src/general";
import { Phone, Mail } from "lucide-react";

export default function TopBar() {
  return (
    <div className="bg-secondary font-medium text-12 text-primary font-primary py-2 h-[40]">
      <div className="max-w-7xl font-primary mx-auto grid grid-cols-3">
        {/* Left: Phone */}
        <div className="flex  items-center gap-2 ">
          <Phone className="w-4 h-4" />
          <a href={`tel:${LABELS.SUPPORT_PHONE}`}>{LABELS.SUPPORT_PHONE}</a>
        </div>

        {/* Center: Promo */}
        <p className="text-center uppercase text-primary">
          {LABELS.TOPBAR_MSG}
        </p>

        {/* Right: Email */}
        <div className="flex justify-end items-center gap-2">
          <Mail className="w-4 h-4" />
          <a href={`mailto:${LABELS.SUPPORT_EMAIL}`}>{LABELS.SUPPORT_EMAIL}</a>
        </div>
      </div>
    </div>
  );
}
